<script>
  import { MDCTextField } from '@material/textfield';
  import { onMount, onDestroy } from 'svelte';
  import { is_character_key_press } from '../utils';
  import { show_message } from '../flash';
  import session from '../session';
  import { t9n } from '../translate';
  import { TS } from '../../config/translation-keys';

  // component options  ------------------------------------------------------ //

  export let id;
  export let data_cy = null;
  export let type = 'text';
  export let label;
  export let name;
  export let value = null;
  export let width = '410px';
  export let height;
  export let leading_icon = null;
  export let trailing_icon = null;
  export let inline = false;
  export let validate = false;
  export let valid = true;
  export let max_char;
  export let variant = 'outlined';
  export let margin_left = '0';
  export let margin_bottom = '16px';
  export let margin_top ;
  export let validation_text;
  export let disabled = false;
  export let is_tooltip_default = false;
  export let tooltip_default_text;
  export let tooltip_default_bg = 'var(--mdc-theme-secondary)';
  export let tooltip_default_color = '#ffffff';
  export let after_valid_text = null;
  export let filled_textarea_label = false;
  export let rows = '3';
  export let cols = '40';
  export let hide_bg = true;
  export let is_required = false;
  export let has_focused = false;

  // internal variables ------------------------------------------------------ //

  let empty = true;
  let focused = false;
  let validated = false;
  let errors = null;
  let validation_delay;

  let switch_on = true;
  let textarea;
  let show = false;
  let timer;
  let input_field;
  let char_num_before = 0;

  // utility functions -------------------------------------------------------- //

  const toggle_link = () => {
    show = !show;
  };

  const toggle_focus = () => {
    focused = !focused;
    has_focused = true;
  };


  const show_password = e => {
    const input = e.target.parentNode.querySelector('input');
    input.type === 'password'
      ? (input.type = 'text')
      : (input.type = 'password');
  };

  const max_char_event = (e) => {
    if(!!max_char){
      if(is_character_key_press(e)){
        if(Number(max_char) === input_field.value.length){
          if(char_num_before !== input_field.value.length){
            char_num_before = input_field.value.length;
          } else{
            show_message(t9n(TS.INPUT_FIELD_MAX_CHAR_ERROR), 'error')
          }
        } else{
          char_num_before = input_field.value.length;
        }
      } else{
        if(e.key === 'Backspace' || e.key === 'Delete'){
          char_num_before = input_field.value.length;
        }
      }
    }
  }

  const init_colors = () => {
    if (is_tooltip_default === true) {
      let element = document.getElementById('tooltip_def');

      if (!!element) {
        element.style.backgroundColor = tooltip_default_bg;
        element.style.color = tooltip_default_color;
      }
    }
    init_text_field();
    input_field = document.getElementById(`input-${id}`);
    if(!!input_field){
      input_field.addEventListener('keyup', (e) => { max_char_event(e) });
    }

  };

  const init_text_field = () => {
    if(type === 'tasks'){
      let element = document.querySelector('.text_area');
      if (!!element) {
        textarea = new MDCTextField(document.getElementById(id));
      }
    }

  };

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const hide_tooltip_on_new_order = () => {
    if (switch_on) {
      if (window.location.href.endsWith('order-new')) {
        if (name === 'team-selector') {
          let tooltip = document.querySelectorAll('.tooltip-default');
          if (tooltip) {
            //let display = getComputedStyle(tooltip[1]).display;
            tooltip[1].style.display = 'none';
            switch_on = false;
          }
        }
      }
    }
  };

  function getAbsPosition(element) {
    var rect = element.getBoundingClientRect();
    return {x:rect.left,y:rect.top}
  }



  const debounce = v => {
    // console.log("debounce", v, value)
    clearTimeout(timer);
    timer = setTimeout(() => {
      value = v
    }, 750);
  }

  // reactive functions ------------------------------------------------------- //

  $: if (focused) hide_tooltip_on_new_order();

  $: if (!!value) {
    empty = false;
  } else {
    empty = value !== 0;
  }

  // $: if (validate && (value || focused)) validate_field(value);

  $: if (!disabled) {
    let element = document.getElementById(id);
    if (!!element) {
      element.classList.remove('mdc-text-field--disabled');
    }
  }
  onMount(init_colors);
  onDestroy(() => {
    if(!!input_field){
      input_field.removeEventListener('keyup', (e) => { max_char_event(e) });
    }

  })
</script>

<svelte:options accessors={true} />

<div class:inline-field-container={inline} style='position: relative; width: inherit'>
  <div
    {id}
    class="mdc-text-field text-field"
    class:mdc-text-field--outlined={variant === 'outlined'}
    class:mdc-text-field--with-leading-icon={leading_icon}
    class:mdc-text-field--with-trailing-icon={trailing_icon}
    class:mdc-text-field--focused={focused}
    class:mdc-text-field--invalid={!valid && focused}
    class:disabled-bg={disabled && hide_bg}
    style={`width: ${width}; height: ${height}; margin-bottom: ${margin_bottom}; margin-left: ${margin_left}; margin-top: ${margin_top}`}>

    {#if leading_icon}
      <i class="material-icons mdc-text-field__icon">{leading_icon}</i>
    {/if}

    {#if trailing_icon}
      <i class="material-icons mdc-text-field__icon">{trailing_icon}</i>
    {/if}

    {#if type === 'password'}
      <input
        type="password"
        class="mdc-text-field__input"
        data-cy={data_cy}
        {name}
        id={`input-${id}`}
        maxlength={max_char}
        bind:value
        {disabled}
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        on:blur={toggle_focus} />
      <!--            <button class="material-icons mdc-text-field__icon reveal_password"-->
      <!--                    on:click|preventDefault={show_password}>-->
      <!--                visibility-->
      <!--            </button>-->
<!--      on:keyup={({ target: { value } }) => debounce(value)}-->
    {:else if type === 'email'}
      <input
        type="email"
        class="mdc-text-field__input"
        data-cy={data_cy}
        id={`input-${id}`}
        {name}
        {disabled}
        maxlength={max_char}
        bind:value
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        on:blur={toggle_focus} />
    {:else if type === 'link'}
      <input
        type="link"
        class="mdc-text-field__input"
        {name}
        {id}
        bind:value
        on:focus={toggle_focus}
        on:click={toggle_link}
        on:change
        on:input
        on:keyup
        on:blur={toggle_focus} />
    {:else if type === 'number'}
      <input
        type="number"
        data-cy={id}
        class="mdc-text-field__input"
        {name}
        maxlength={max_char}
        bind:value
        id={`input-${id}`}
        {disabled}
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        on:blur={toggle_focus} />
    {:else if type === 'float'}
      <input
        type="number"
        class="mdc-text-field__input"
        {name}
        maxlength={max_char}
        bind:value
        id={`input-${id}`}
        {disabled}
        step="0.01"
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        on:blur={toggle_focus} />
    {:else if type === 'url'}
      <input
        type="url"
        class="mdc-text-field__input"
        {name}
        maxlength={max_char}
        bind:value
        {disabled}
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        id={`input-${id}`}
        on:blur={toggle_focus} />
    {:else if type === 'tel'}
      <input
        type="tel"
        class="mdc-text-field__input"
        id={`input-${id}`}
        {name}
        maxlength={max_char}
        bind:value
        {disabled}
        on:focus={toggle_focus}
        on:input
        on:change
        on:keyup
        on:blur={toggle_focus} />
    {:else if type === 'hidden'}
      <input
        type="hidden"
        class="mdc-text-field__input"
        {name}
        {disabled}
        maxlength={max_char}
        value />
    {:else if type === 'tasks'}
      <textarea
        data-cy={id}
        bind:value
        id={`input-${id}`}
        style="padding: 27px 16px 6px; resize: none;"
        on:focus={toggle_focus}
        on:blur={toggle_focus}
        class="mdc-text-field__input text_area"
        {rows}
        {cols}
        {disabled}
        maxlength={max_char} />
    {:else}
      <input
        type="text"
        data-cy={id}
        class="mdc-text-field__input"
        class:no-pointer={disabled}
        bind:value
        {name}
        id={`input-${id}`}
        maxlength={max_char}

        {disabled}
        on:focus={toggle_focus}
        on:input
        on:keyup
        on:change
        on:blur={toggle_focus} />
    {/if}

    {#if variant === 'outlined'}
      <div
        class="mdc-notched-outline"
        class:mdc-notched-outline--upgraded={focused || !empty}
        class:mdc-notched-outline--notched={focused || !empty}>
        <div class="mdc-notched-outline__leading" />

        <div class="mdc-notched-outline__notch">
          <label
            class="mdc-floating-label"
            class:mdc-floating-label--float-above={focused || !empty}>
            {label} {#if is_required}*{/if}
          </label>
        </div>

        <div class="mdc-notched-outline__trailing" />
      </div>
    {:else if variant === 'filled'}
      <div class="mdc-line-ripple" />
      {#if filled_textarea_label}
        <label
          for="text-field-hero-input"
          class:mdc-floating-label--float-above2={!empty}
          class:mdc-floating-label--float-above3={focused}
          class:label-bg={focused}
          class:label-tasks={type === 'tasks'}
          class="mdc-floating-label">
          {label} {#if is_required}*{/if}
        </label>
      {:else}
        <label
          for="text-field-hero-input"
          class:mdc-floating-label--float-above={focused || !empty}
          class:label-bg={focused}
          class:label-tasks={type === 'tasks'}
          class="mdc-floating-label">
          {label} {#if is_required}*{/if}
        </label>
      {/if}
    {/if}
  </div>

  {#if !valid && !!validation_text}
    <div class="tooltip-error">
      <span class="tooltip-text tooltip-top">{validation_text}</span>
    </div>
  {/if}

  {#if !!value && valid && after_valid_text !== null && after_valid_text !== undefined && after_valid_text.length > 0}
    <div class="tooltip-valid">
      <span class="tooltip-text tooltip-top">{after_valid_text}</span>
    </div>
  {/if}

  {#if is_tooltip_default && valid && !has_focused}
      <div class="tooltip-default ">
        <span id="tooltip_def" class="tooltip-text tooltip-top">
          {tooltip_default_text}
        </span>
      </div>
  {/if}

  {#if valid && show && value != null && value.length > 6}
    <div class="tooltip-link">
      <a
        class="tooltip-text2 tooltip-top2"
        id="link"
        style="color: #525252;"
        href={value}
        target="_blank">
        Test link
      </a>
    </div>
  {/if}

</div>

<style>
    .require-margin{
        margin-bottom: 30px;
    }
    .mdc-form-field{
        position: absolute;
        left: 0;
        top: 65px;
    }

    .mdc-form-field label{
        white-space: nowrap;
    }
  .label-tasks {
    margin-top: -70px;
  }
  .mdc-text-field {
    width: auto;
    transition: all 0.2s ease-in-out;
  }

  .no-pointer {
    cursor: not-allowed;
  }

  .mdc-floating-label--float-above2 {
    /*top: 33%;*/
    background: #f5f5f5;
    /*border-top: solid #f5f5f5;*/
    padding-top: 5px;
    box-shadow: 0 0px 9px 9px #f5f5f5;
  }

  .mdc-floating-label--float-above3 {
    /*top: 33%;*/
    background: #f5f5f5;
    /*border-top: solid #f5f5f5;*/
    padding-top: 5px;
    box-shadow: 0 0px 9px 9px #dcdcdc;
  }

  .label-bg {
    z-index: 10;
    background-color: #dcdcdc;
  }

  .mdc-text-field-helper-line {
    position: relative;
    top: -16px;
  }

  .reveal_password {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    z-index: 2;
    pointer-events: all;
  }

  .inline-field-container {
    display: inline-block;
  }

  ul.errors {
    padding-left: 0;
    position: relative;
    top: -16px;
    text-align: left;
  }

  .tooltip-valid {
    position: relative;
    font-size: 12px;
    top: -60px;
    /*animation: transition_in 0.6s;*/
  }

  .tooltip-valid .tooltip-top {
    position: absolute;
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
    right: 0;
    left: 50%;
  }

  .tooltip-valid .tooltip-text {
    background-color: #069;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
  }

  .tooltip-default {
    position: relative;
    font-size: 13px;
    top: -67px;
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    position: absolute;
    z-index: 5;
    bottom: 100%;
    right: 0;
    left: 20%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    width: 77%;
  }

  .tooltip-error {
    position: relative;
    font-size: 12px;
    top: -60px;
      opacity: 0;
      animation: transition_in 0.5s;
      animation-delay: 2s;
      animation-fill-mode: forwards;
    /*animation: transition_in 0.6s;*/
  }

  .tooltip-error .tooltip-top {
    position: absolute;
    z-index: 1;
    bottom: 100%;
    right: 3px;
    left: 50%;
    /*right: 0;*/
    /*left: 50%;*/
  }

  .tooltip-error .tooltip-text {
    background-color: #b00020;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -90px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .disabled-bg {
    /*background-color: #d6d6d6;*/
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
  }

  /* Tablet Mode
      *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    /*.mdc-text-field {*/
    /*  !*width: 149% !important;*!*/
    /*  width: 100% !important;*/
    /*}*/
  }

  /* Mobile Mode
      *******************************************************/

  @media (min-width: 0) and (max-width: 768px) {
    .mdc-text-field {
      width: 100% !important;
    }
  }
</style>
